import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M4 4v21.5h22\"></path><path stroke-dasharray=\"1.6 2.2\" d=\"M6.5 11H26M6.5 19H26\"></path><circle cx=\"9\" cy=\"15\" r=\"1.6\" fill=\"currentColor\" stroke=\"none\"></circle><circle cx=\"13\" cy=\"13.5\" r=\"1.6\" fill=\"currentColor\" stroke=\"none\"></circle><circle cx=\"17\" cy=\"16.5\" r=\"1.6\" fill=\"currentColor\" stroke=\"none\"></circle><circle cx=\"21\" cy=\"6\" r=\"1.6\" fill=\"currentColor\" stroke=\"none\"></circle><circle cx=\"24.5\" cy=\"14.5\" r=\"1.6\" fill=\"currentColor\" stroke=\"none\"></circle>", 7)
  ]))]))
}
export default { render: render }